const sizeMap = {
	S: '84-88 cm',
	M: '92-96 cm',
	L: '100-104 cm',
	X: '108-112 cm',
	XL: '116-120 cm',
	XXL: '124-128 cm',
	XXXL: '132-136 cm',

	XS: '80-84 cm',
	XXS: '76-80 cm',
	XXXXL: '140-144 cm',

	'4': '84-86 cm',
	'6': '88-90 cm',
	'8': '92-94 cm',
	'10': '96-98 cm',
	'12': '100-102 cm',
	'14': '104-106 cm',
	'16': '108-110 cm',
	'18': '112-114 cm',

	'35': '22.5 cm',
	'36': '23 cm',
	'37': '23.5 cm',
	'38': '24 cm',
	'39': '24.5 cm',
	'40': '25 cm',
	'41': '25.5 cm',
	'42': '26 cm',
	'43': '26.5 cm',
	'44': '27 cm',
	'45': '27.5 cm',
	'46': '28 cm',
} as const

export default sizeMap
